import { render, staticRenderFns } from "./ApprTemp2.vue?vue&type=template&id=8c3df92c&scoped=true&"
import script from "./ApprTemp2.vue?vue&type=script&lang=js&"
export * from "./ApprTemp2.vue?vue&type=script&lang=js&"
import style0 from "./ApprTemp2.vue?vue&type=style&index=0&id=8c3df92c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3df92c",
  null
  
)

export default component.exports